// Angular
import { Observable, first, map } from 'rxjs';
import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

// Libraries
import { MatDialog } from '@angular/material/dialog';

// Components
import { ConfirmDialogComponent } from '../dialogs/confirm-dialog/confirm-dialog.component';

// Models
import { AppCleanup } from '../models';

// Environment
import { environment } from '../../../environments/environment';

@Injectable()
export class PasswordGuard extends AppCleanup implements OnInit, OnDestroy {
	previousNavigation: any;

	constructor(
		private router: Router,
		private dialog: MatDialog
	) {
		super();
		this.previousNavigation = this.router?.getCurrentNavigation()?.previousNavigation;
	}

	ngOnInit() {}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return this.authorized();
	}

	canActivateChild(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return this.authorized();
	}

	private authorized(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			data: {
				message: `This page is password protected. Please, enter the password`,
				password: environment.defaultSecret,
			},
			autoFocus: false,
		});

		return dialogRef.afterClosed().pipe(
			map((result) => {
				if (!this.previousNavigation && !result) {
					this.router.navigate(['/']); // This is needed so that when you don't have a previous url, it will redirect you to route. Otherwise, the page will stay blank.
				}

				return result;
			}),
			first()
		);
	}
}
